module.exports = __webpack_public_path__ + "images/59809659bdedef44bc8d5c8b5c7b7462.png";